// extracted by mini-css-extract-plugin
export default {"tag":"DayTypeIcon_tag__5G5Wb"};